import { useMemo, useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { FlexGrid, Typography, useDialog } from "@albo-ui/core";
import { status, sellerRole } from "../../../../util/DataObject";
import { ModalStyle } from "../../../../util/Styles";
import { useCRMFunction } from "./useCRMFunction";
import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
moment.locale("es");

export const useCRMCommission = ( changeAlert: ChangeAlertCallbackType ) => {
    const { onHandleGetData, onHandleGetByUuid, onHandleCommissionUpdate } = useCRMFunction(changeAlert);

    const [data, setData] = useState([]);
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [formFind, setFormFind] = useState({ filters: {} });
    const [form, setForm] = useState({
        filters: { type: "lead" },
    });

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [totalDocuments, setTotalDocuments] = useState(0);
    const [tabActive, setTabActive] = useState("lead");
    const tabs = [
        { name: "lead", title: "Deals" },
        { name: "seller", title: "Sellers" },
    ];

    const [dialogText, setDialogText] = useState({});
    const [row, setRow] = useState(null);
    const dialogConfirm = useDialog();
    const dialogProps = useDialog();
    const agent = localStorage.session ? JSON.parse(localStorage.session) : {};

    const saveData = async (result) => {
        let validate = Array.isArray(result?.content);
        setData(JSON.parse(JSON.stringify(validate ? result.content || [] : [result.content])));
        setTotalDocuments( result.pagination ? result.pagination["total_documents"] : 0);
    };

    const getData = async (newPage = page, newPerPage = rowsPerPage, form, tab) => {
        setLoading(true);
        let searchType = formFind["filters"]["keyword"] ? "Find" : "List";
        let service = `commissionCrm${searchType}`;

        let f = {};
        if (searchType === "List") {
            f = form;
            f["filters"]["type"] = tab;
            f["pagination"] = {
                page_number: newPage,
                results_per_page: newPerPage,
            };
            setForm(JSON.parse(JSON.stringify(f)));
        } else {
            f = formFind;
            f["filters"]["type"] = tab;
            f["pagination"] = {
                page_number: newPage,
                results_per_page: newPerPage,
            };
            form["filters"]["status"] && (f["filters"]["status"] = form["filters"]["status"]);
            setFormFind(JSON.parse(JSON.stringify(f)));
        }

        let resp = await onHandleGetData(f, service);
        resp ? saveData(resp) : saveData({ content: [] });
        setLoading(false);
    };

    const onUpdateCommissions = async (lead, section) => {
        setLoading(true);
        
        let resp = await onHandleCommissionUpdate(lead, agent);
        resp ? onHandleSearch() : setLoading(false);
    };

    const onHandleSearch = () => {
        getData(1, rowsPerPage, form, tabActive);
    };

    const changeTab = (tab: string, storedForm?) => {
        setTabActive(tab);
        setData([]);
        clearInput();
        getData(1, rowsPerPage, storedForm ? storedForm : form, tab);
    };

    const onHandleChangeFind = (key1, key2, e) => {
        let f = formFind;
        let value = e.target.value;

        if (f["filters"]["search_type"] === "email") {
            value = value.trim();
        }
        if (key1 === "search_type") {
            f = {filters: {}};
        }
        if (key2 && value) {
            f["filters"][key1]
                ? (f["filters"][key1][key2] = value)
                : (f["filters"][key1] = { [key2]: value });
        } else if (key1 && value) {
            f["filters"][key1] = value;
        } else if (key1 && !value) {
            delete f["filters"][key1];
        }

        setFormFind(JSON.parse(JSON.stringify(f)));
    };

    const onChangeEdit = (register) => {
        setItem(register);
        dialogProps.openDialog();
    };

    const onConfirmDelete = (row) => {
        setRow(row);
        setDialogText({
            title: "Eliminar registro",
            message: `¿Está seguro que desea eliminar las comisiones de la siguiente Empresa?. Recuerda que dichos porcentajes también serán eliminados de cada comisionista.`,
        });
        dialogConfirm.openDialog();
    };

    const onHandleDelete = async () => {
        setLoading(true);
        dialogConfirm.onClose();
        
        const payload = row[tabActive === "seller" ? "companies" : "sellers"].map((i) => {
            return {
                uuid: i.ref_uuid,
                status: "disabled",
                active: false,
                updated_by: agent["uuid"],
            }
        });

        let resp = await onHandleCommissionUpdate(payload, agent);
        resp ? getData(page, rowsPerPage, form, tabActive) : setLoading(false);

        setRow(null);
    };

    const changePage = (action, page, rows = rowsPerPage) => {
        setPage(page + 1);
        getData(page + 1, rows, form, tabActive);
    };
    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setRowsPerPage(JSON.parse(JSON.stringify(event.target.value)));
        changePage(null, 0, parseInt(event.target.value, 10));
    };

    const expandInfo = (info) => {
        return info["data"][tabActive === "seller" ? "companies" : "sellers"]?.map((value, i) => (
            <FlexGrid key={i} container style={{ marginLeft: 65 }}>
                <FlexGrid item style={{ width: 270 }}>
                    <Typography variant="paragraph" color="lightNeutral" style={{ paddingRight: 20 }}>
                        {tabActive === "seller" ? "Empresa:" : "Vendedor:"}
                    </Typography>
                    <Typography variant="paragraph">
                        {value["company_name"] || value["name"]}
                    </Typography>
                </FlexGrid>
                <FlexGrid item style={{ width: 250 }}>
                    <Typography variant="paragraph" color="lightNeutral" style={{ paddingRight: 20 }}>
                        Porcentaje de Comisión:
                    </Typography>
                    <Typography variant="paragraph">{value["commission"]} %</Typography>
                </FlexGrid>
                {tabActive !== "seller" && (
                    <FlexGrid item style={{ width: 150 }}>
                        <Typography variant="paragraph" color="lightNeutral" style={{ paddingRight: 20 }}>
                            Rol:
                        </Typography>
                        <Typography variant="paragraph">{sellerRole.map((item) => item.key === value["role"] ? item.label : null)}</Typography>
                    </FlexGrid>
                )}
                <FlexGrid item style={{ width: 200 }}>
                    <Typography variant="paragraph" color="lightNeutral" style={{ paddingRight: 20 }}>
                        Estatus comisión:
                    </Typography>
                    <Typography variant="paragraph">{status.map((item) => value["status"] === item.value ? item.label : null)}</Typography>
                </FlexGrid>
            </FlexGrid>
        ));
    };
    const clearInput = () => {
        let f = formFind;
        formFind["filters"] = {};
        setFormFind(JSON.parse(JSON.stringify(f)));
    };

    const calculateColumns = useMemo(() => {
        const columns = [];

        tabActive === "seller" &&
            columns.push(
                { selector: (row) => row["name"], name: "Nombre", wrap: true, sortable: true},
                { selector: (row) => row["email"], name: "Correo", wrap: true, sortable: true},
                { selector: (row) => sellerRole.map((item) => item.key === row["role"] ? item.label : null), name: "Rol", wrap: true, sortable: true}
            );
        tabActive === "lead" &&
            columns.push(
                { selector: (row) => row["company_name"], name: "Nombre de la Empresa", wrap: true, sortable: true, width: "30%"},
                { selector: (row) => row["onboarding_email"], name: "Correo", wrap: true, sortable: true, width: "30%"},
                { selector: (row) => moment(new Date(row["cdate"])).tz("America/Mexico_City").format("L"), name: "Fecha de creación", wrap: true, sortable: true}
            );
        // columns.push({
        //     cell: (row) => {
        //         return (
        //             <select value={row.status} onChange={onChangeEdit.bind(this, row)} disabled={row.status === "disabled" ? true : false}>
        //                 {status.map((item, index) => <option key={`state-${index}`} value={item.value}>{item.label}</option>)}
        //             </select>
        //         );
        //     }, name: "Estatus comisión", wrap: true, sortable: true, center: true
        // });
        columns.push({
            cell: (row) => {
                return (
                    <ModalStyle property={String(false)}>
                        <Button onClick={onChangeEdit.bind(this, row)} sx={{ minWidth: "40px", p: 0.7, mr: 2 }} variant="contained" color="secondary">
                            <EditIcon />
                        </Button>
                        <Button onClick={onConfirmDelete.bind(this, row)} sx={{ minWidth: "40px", p: 0.7 }} variant="contained" color="secondary">
                            <DeleteIcon />
                        </Button>
                    </ModalStyle>
                );
            }, name: "Acciones", wrap: true, sortable: true, center: true,
        });

        return columns;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabActive]);

    return {
        data,
        item,
        formFind,
        columns: calculateColumns,
        loading,
        tabs,
        tabActive,
        pagination: { page, rowsPerPage, totalDocuments },
        dialogProps,
        dialogConfirm,
        dialogText,
        row,
        getData,
        saveData,
        onHandleSearch,
        onHandleChangeFind,
        onHandleGetByUuid,
        onUpdateCommissions,
        onHandleDelete,
        clearInput,
        changeTab,
        expandInfo,
        changePage,
        handleChangeRowsPerPage,
        setRow
    };
};
